/* Copyright (c) 2021-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import styled from "styled-components";
import { theme } from "@nordcloud/gnui";

export const DropdownWrapStyle = styled.div`
  position: relative;
  cursor: pointer;
  z-index: 100;
`;

export const ShowDropDown = styled.div`
  background: ${theme.color.background.ui01};
  transition: all 0.2s ease-in-out;
  position: absolute;
  opacity: 0;
  visibility: hidden;
  border-bottom-right-radius: 4px;
  border-bottom-left-radius: 4px;
  top: 100%;
  left: 0;
  width: 100%;
  z-index: 100;
  ${/* sc-selector */ DropdownWrapStyle}:hover & {
    opacity: 1;
    visibility: visible;
    box-shadow: ${theme.shadow.shadow04};
  }
`;

export const ArrowWrap = styled.div`
  display: block;

  svg {
    transition: transform 0.2s ease-in-out;
  }
  ${/* sc-selector */ DropdownWrapStyle}:hover & {
    svg {
      transform: rotate(180deg);
      transform-origin: center center;
    }
  }
`;

export const BoxWrap = styled.div`
  min-width: 0;
  padding: 0.55rem 1.25rem 0.55rem 1.25rem;
  color: ${theme.color.text.text01};
  background: ${theme.color.background.ui01};
  border-radius: 4px;
  transition: box-shadow 0.2s ease-in-out;
  ${/* sc-selector */ DropdownWrapStyle}:hover & {
    box-shadow: ${theme.shadow.shadow04};
  }
`;

export const DropList = styled.ul`
  border-radius: ${theme.radius.md};
  padding: 0.5rem;
  margin-bottom: 0;
`;

export const DropItem = styled.li`
  display: flex;
  align-items: center;
  justify-items: center;
  padding: 0.5rem 0.2rem;
  font-size: 16px;
  cursor: pointer;

  :hover {
    opacity: 0.7;
  }

  &:last-of-type {
    border-top: 1px solid ${theme.color.border.border01};
  }
`;

export const DropButton = styled.button`
  flex: 1;
  padding: 0;
  background: none;
  display: flex;
  align-items: center;
  justify-items: center;
  border: none;
  cursor: pointer;
  color: ${theme.color.text.text01};

  &:focus {
    outline: none;
  }
`;

export const IconWrap = styled.div`
  display: flex;
  margin-right: 1rem;
`;
